import { patientJourney } from '@/mocks/homeData';

export default function PatientJourneySection() {
  return (
    <section id="jornada" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-xs uppercase tracking-[0.2em] text-primary-500 font-semibold mb-3 block">
            Sua jornada
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl mx-auto">
            Do primeiro contato ao sorriso transformado
          </h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-[10%] right-[10%] h-px bg-background-300 -translate-y-1/2"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {patientJourney.map((item, index) => (
              <div key={item.step} className="relative text-center group">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-50 rounded-full border-2 border-accent-300 transition-all duration-500 group-hover:border-accent-500 group-hover:bg-accent-50 relative z-10">
                  <span className="font-heading text-lg font-bold text-accent-600">
                    {item.step}
                  </span>
                </div>
                <i className={`${item.icon} text-accent-500 text-xl block mb-3`}></i>
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed px-2">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}